import Vue from 'vue'
import Router from 'vue-router'
import { getMenuList,getLeaderMenuList } from "../utils/interface";

import loginPage from '@/views/login/index'  //登录
import main from '@/views/index'
import homePage from '@/views/home/homePage'  //首页
// 评审中心
import examineCenter from '@/views/examine/examineCenter'
// 领导审核
import leaderExamine from '@/views/examine/leaderExamine'

Vue.use(Router)
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            redirect: '/login',
            component: loginPage,
        },
        {
            path: '/login',
            name: 'login',
            component: loginPage,
        },
        {
            path: '/examine',
            name: 'examine',
            redirect: '/examineCenter',
            component: main,
            children: [
                /*{
                    path: '/home',
                    name: 'home',
                    component: homePage,
                    meta: { title: '首页' }
                },*/
                {
                    path: '/examine',
                    name: 'examine',
                    component: examineCenter,
                    meta: { title: '作品列表' }
                },
                {
                    path: '/leaderExamine',
                    name: 'leaderExamine',
                    component: leaderExamine,
                    meta: { title: '领导审核' }
                },
            ]
        },
    ]
})
router.beforeEach((to, from, next) => {

    let token = $cookies.get("api_token_new");
    let reviewExamineMess = $cookies.get("reviewExamineMess");

    // let menuList = JSON.parse(window.sessionStorage.getItem('menuList') || '[]')
    if (to.name !== 'login' && !token) {
        next({ name: 'login' })
        return
    }
    // if(to.name === 'login' && token && menuList.length > 0){
    if(to.name === 'login' && token && reviewExamineMess == 'reviewCenterService'){
        next({ name: 'examine' })
        return
    }

    // console.log('reviewExamineMess', $cookies.get("reviewExamineMess"));
    if(token &&  reviewExamineMess != 'reviewCenterService') {
        getMenuList().then(res=>{
            if(res.length > 0){
                window.sessionStorage.setItem('menuList', JSON.stringify(res || []))
                Vue.prototype.resetSetItem('menuActiveId', res[0].uuid)
                // 成功后直接跳转
                next({name: 'examine'})
                return
            } else {
                Vue.prototype.$alert('权限不足，请联系管理员!', "提示", {
                    confirmButtonText: "确定",
                    callback: action => {
                        next({ name: 'login' })
                        return
                    }
                })
            }
        })
    }

    next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js